"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Tracks when an element enters the viewport for scroll-triggered animations.
 * Returns a ref and an inView boolean that flips to true once on entry — never resets.
 */
export const useInView = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return { ref, inView };
};
